import React from 'react';
import {Container, Stack} from "@mui/material";
import BreadPath from "../BreadPath/BreadPath";
import {Button, Flex} from "antd";
import { Card, Image,Badge, Space } from "antd";
import  IMG_ZIM from "../../Images/ZIM.png"
import  IMG_SUM from "../../Images/SUM.png"
import  IMG_BS from "../../Images/BS.png"
import  IMG_PRO from "../../Images/PRO.png"
import  IMG_NEO from "../../Images/NEO.png"
import  IMG_FM from "../../Images/FM.png"
import  HBPRO from "../../Images/HB_PRO.png"
import  HBEXT from "../../Images/HB_EXT.png"
import  HBSTD from "../../Images/HB_STD.png"
import  C1M from "../../Images/1M.png"
import  C2M from "../../Images/2M.png"
import  C3M from "../../Images/3M.png"
import  C6M from "../../Images/6M.png"
import  C9M from "../../Images/9M.png"
import  C12M from "../../Images/12M.png"
import  C24M from "../../Images/24M.png"
import  XXM from "../../Images/XXM.png"
import  BKKT from "../../Images/BKKT.webp"
import  BFZKZ from "../../Images/BFZKZ.png"
import  HobaMyPrint from "../../Images/HobaMyPrint.jpg"


import { Typography} from  "antd";
import  Cifra from "../../Images/Cifra.png"
import NewCategory from "../NewCategory/NewCategory";
import { FaRegSnowflake } from "react-icons/fa";
import { FaSun } from "react-icons/fa";
import { FaCanadianMapleLeaf } from "react-icons/fa";
import { LuSun } from "react-icons/lu";
import {baseUrl_back} from "../../api/BaseUrl";
import OneCategoryGlassNew from "../OneCategoryGlassNew/OneCategoryGlassNew";
import NewCifraTovar from "../newCifraTovar/newCifraTovar";
import {StyledDescription} from "../Description/styled";
import ProductSlider from "../ProductCarusel/ProductSlider";
import {color} from "three/nodes";
import BackGround from "../BackGround/BackGround";
// import Paragraph from "antd/es/skeleton/Paragraph";
const Bread=[{key:"Главная", link:"/"}, {key:"Каталог", link:"/newcatalog"}]
const baseStyle: React.CSSProperties = {
    width: '25%',
    height: 54,
};
const { Title } = Typography;
const { Paragraph, Text } = Typography;
const  NewCatalog = () => {
    return (
        <Container  maxWidth="xl">

            <Stack>
                {/*<button onClick={tocatalog} className="glow-on-hover" type="button">Перейти в каталог</button>*/}
                {/*<p></p>*/}
                {/*<h3 className={"myFont_lg"}>Популярные товары</h3>*/}
                {/*<ProductSlider/>*/}
                {/*<MultiItemCarusel callbackX={props.callbackX}/>*/}
            </Stack>
            <BreadPath   path={Bread}/>
            <Button style={{ backgroundColor:"#382b2f"}} color="default" size={"large"} variant="solid" block>БАФФЫ</Button>
            <p></p>
            <Flex wrap justify={"space-evenly"} vertical={false}>
                <NewCategory mylink={"/category/BN-ZIM"} imgs={IMG_ZIM} newwind={false} catname={"Теплые ZIM"} season={<><FaRegSnowflake /> Зима </>} fcolor={"white"} seasonColor={"blue"}/>
                <NewCategory mylink={"/category/BK-FL"} imgs={BKKT} newwind={false} catname={"Теплые комбинированные"} season={<><FaRegSnowflake /> Зима </>} fcolor={"white"} seasonColor={"blue"}/>
                <NewCategory mylink={"/category/BN-SUM"} imgs={IMG_SUM} newwind={false} catname={"Летние"} season={<><LuSun /> Лето </>} fcolor={"black"} seasonColor={"yellow"}/>
                <NewCategory mylink={"/category/BN-PRO"} imgs={IMG_PRO} newwind={false} catname={"Осенние"} season={<><FaCanadianMapleLeaf /> Осень</>} fcolor={"white"} seasonColor={"volcano"}/>
                <NewCategory mylink={"/category/BN-BS"} imgs={IMG_BS} newwind={false} catname={"Бесшовные"} season={<><LuSun /> Лето </>} fcolor={"black"} seasonColor={"yellow"}/>
                <NewCategory mylink={"/category/BN-NEO"} imgs={IMG_NEO} newwind={false} catname={"Неоновые"} season={<><LuSun /> Лето </>} fcolor={"black"} seasonColor={"yellow"}/>
                <NewCategory mylink={"/category/BN-FM"} imgs={IMG_FM} newwind={false} catname={"С плоским швом"} season={<><LuSun /> Лето </>} fcolor={"black"} seasonColor={"yellow"}/>
                {/*<NewCategory mylink={"/zakazBuff"} imgs={BFZKZ} catname={"На заказ"} season={<><LuSun /> Любой </>} fcolor={"white"} seasonColor={"magenta"}/>*/}
                <NewCategory mylink={"https://taplink.cc/gobananas/p/createbuff/"} newwind={true} imgs={BFZKZ} catname={"На заказ"} season={<><LuSun /> Любой </>} fcolor={"white"} seasonColor={"magenta"}/>

            </Flex>


            <Button style={{marginTop: "20px", backgroundColor: "#382b2f"}} color="default" size={"large"}
                    variant="solid" block>ХОБЫ (туристические сидушки)</Button>
            <p></p>
            <Flex wrap justify={"space-evenly"} vertical={false}>
                <NewCategory mylink={"/category/HB-STD"} imgs={HBSTD} newwind={false} catname={"Толщина 10мм"} season={<><LuSun /> 10мм </>} fcolor={"black"} seasonColor={"yellow"}/>
                <NewCategory mylink={"/category/HB-EXT"} imgs={HBEXT} newwind={false} catname={"Толщина 15мм"} season={<><FaCanadianMapleLeaf /> 15мм </>} fcolor={"white"} seasonColor={"volcano"}/>
                <NewCategory mylink={"/category/HB-PRO"} imgs={HBPRO} newwind={false} catname={"Толщина 20мм"} season={<><FaRegSnowflake/> 20мм</>} fcolor={"white"} seasonColor={"blue"}/>
                {/*<NewCategory mylink={"/zakazHoba"} imgs={HobaMyPrint} catname={"На заказ"} season={<><FaCanadianMapleLeaf /> любая</>} fcolor={"white"} seasonColor={"magenta"}/>*/}
                <NewCategory mylink={"https://taplink.cc/gobananas/p/hobacreate/"} newwind={true} imgs={HobaMyPrint} catname={"На заказ"} season={<><FaCanadianMapleLeaf /> любая</>} fcolor={"white"} seasonColor={"magenta"}/>


            </Flex>

            <Button style={{marginTop: "20px", backgroundColor: "#382b2f"}} color="default" size={"large"}
                    variant="solid" block>Электронные товары (скидки)</Button>
            <p></p>
            <Flex wrap justify={"space-evenly"} vertical={false}>
                <NewCifraTovar mylink={"/Digital/Cyfra_1M"} imgs={C1M} catname={<><a>Предоставление премиум</a> <p>доступа на 1 месяц</p></>} season={<><FaRegSnowflake /> 10мм </>} fcolor={"white"} seasonColor={"blue"}/>
                <NewCifraTovar mylink={"/Digital/Cyfra_2M"} imgs={C2M} catname={<><a>Предоставление премиум</a> <p>доступа на 2 месяца</p></>} season={<><FaRegSnowflake /> 10мм </>} fcolor={"white"} seasonColor={"blue"}/>
                <NewCifraTovar mylink={"/Digital/Cyfra_3M"} imgs={C3M} catname={<><a>Предоставление премиум</a> <p>доступа на 3 месяца</p></>} season={<><FaRegSnowflake /> 10мм </>} fcolor={"white"} seasonColor={"blue"}/>
                <NewCifraTovar mylink={"/Digital/Cyfra_6M"} imgs={C6M} catname={<><a>Предоставление премиум</a> <p>доступа на 6 месяцев</p></>} season={<><FaRegSnowflake /> 10мм </>} fcolor={"white"} seasonColor={"blue"}/>
                <NewCifraTovar mylink={"/Digital/Cyfra_9M"} imgs={C9M} catname={<><a>Предоставление премиум</a> <p>доступа на 9 месяцев</p></>} season={<><FaRegSnowflake /> 10мм </>} fcolor={"white"} seasonColor={"blue"}/>
                <NewCifraTovar mylink={"/Digital/Cyfra_12M"} imgs={C12M} catname={<><a>Предоставление премиум</a> <p>доступа на 12 месяцев</p></>} season={<><FaRegSnowflake /> 10мм </>} fcolor={"white"} seasonColor={"blue"}/>
                <NewCifraTovar mylink={"/Digital/Cyfra_24M"} imgs={C24M} catname={<><a>Предоставление премиум</a> <p>доступа на 24 месяца</p></>} season={<><FaRegSnowflake /> 10мм </>} fcolor={"white"} seasonColor={"blue"}/>
                <NewCifraTovar mylink={"/Digital/Cyfra_XM"} imgs={XXM} catname={<><a>Предоставление премиум</a> <p>договорная</p></>} season={<><FaRegSnowflake /> 10мм </>} fcolor={"white"} seasonColor={"blue"}/>
            </Flex>
            {/*<OneCategoryGlassNew key={"ddd"} label={"dddd"} img={"https://api.go-bananas.ru/Static/Images/Categories/Category_Tsifrovye_tovary.png"}  urlx={""}/>*/}
            <BackGround/>
        </Container>
    );
};

export default NewCatalog;